// @generated by TypeGen from LogbookApi/SyncableApi - DO NOT EDIT

import type { IAppResponse } from "../LogbookApp/Routes"
import type { ISyncUpdateRequest } from "../LogbookApp/SyncableApi"
import { IShipUserLevel } from "../LogbookModel/ShipUser"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface SyncableApiEndpoints {
  "POST /api/sync/retry": {
    params: {};
    query: {};
    request: never;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
  "PUT /api/sync": {
    params: {};
    query: {};
    request: ISyncUpdateRequest;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
}

export const syncableApiEndpoints = {
  "POST /api/sync/retry": { targets: ["app"], permission: { session: true } },
  "PUT /api/sync": { targets: ["app"], permission: { ship: IShipUserLevel.primary } },
} as const;

export class SyncableApi {
  constructor(private client: ApiClient) {}

  sync = {
    retry: (a: ApiArgs<SyncableApiEndpoints, "POST /api/sync/retry">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "POST /api/sync/retry", syncableApiEndpoints["POST /api/sync/retry"].targets);
        return this.client.call<IAppResponse>("POST /api/sync/retry", a);
      },
      url: (): string => this.client.url("POST /api/sync/retry", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
    update: (a: ApiArgs<SyncableApiEndpoints, "PUT /api/sync">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "PUT /api/sync", syncableApiEndpoints["PUT /api/sync"].targets);
        return this.client.call<IAppResponse>("PUT /api/sync", a);
      },
      url: (): string => this.client.url("PUT /api/sync", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.primary,
    }),
  };
}
